export default [
    {field: 'leadSource/campaign', isDefault: false},
    {field: 'leadSource/medium', isDefault: false},
    {field: 'leadSource/source', isDefault: false},
    {field: 'leadSource/term', isDefault: false},
    {field: 'leadSource/content', isDefault: false},
    {field: 'leadSource/affiliate', isDefault: false},
    {field: 'leadSource/subAffiliate', isDefault: false},
    {field: 'leadSource/salesAgent', isDefault: false},
    {field: 'leadSource/amount', isDefault: false},
    {field: 'leadSource/path', isDefault: false},
    {field: 'leadSource/ipAddress', isDefault: false},
    {field: 'leadSource/clickId', isDefault: false},
    {field: 'leadSource/createdTime', isDefault: false},
    {field: 'leadSource/updatedTime', isDefault: false},
    {field: 'leadSource/original/campaign', isDefault: false},
    {field: 'leadSource/original/medium', isDefault: false},
    {field: 'leadSource/original/source', isDefault: false},
    {field: 'leadSource/original/term', isDefault: false},
    {field: 'leadSource/original/content', isDefault: false},
    {field: 'leadSource/original/affiliate', isDefault: false},
    {field: 'leadSource/original/subAffiliate', isDefault: false},
    {field: 'leadSource/original/salesAgent', isDefault: false},
    {field: 'leadSource/original/amount', isDefault: false},
    {field: 'leadSource/original/path', isDefault: false},
    {field: 'leadSource/original/ipAddress', isDefault: false},
    {field: 'leadSource/original/clickId', isDefault: false},
    {field: 'leadSource/original/createdTime', isDefault: false},
    {field: 'leadSource/original/updatedTime', isDefault: false},
];
